import apiSlice from "./apiSlice";


const vendorDashSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getTopPerforming: builder.query({
            query: (req) => ({
                url: `vendor/vendor-performance/top-performing`,
                params: req,
            }),
        }),

        getNonPerforming: builder.query({
            query: (req) => ({
                url: `vendor/vendor-performance/non-performing`,
                params: req,
            }),
        }),

        getListAllVendors: builder.query({
            query: (req) => ({
                url: `vendor/vendor-performance/all-vendors`,
                params: req,
            }),
        }),
        getMatrixData: builder.query({
            query: (req) => ({
                url: `vendor/vendor-performance/by-category`,
                params: req,
            }),
        }),
    }),
});

export const {
    useGetTopPerformingQuery,
    useGetNonPerformingQuery,
    useGetListAllVendorsQuery,
    useGetMatrixDataQuery
} = vendorDashSlice;